import React, { useState, useEffect } from "react";
import "../resources/LogInPage.css"; // Import CSS for styling
import FullLogo from "../resources/artiqlogo.png";
import { notify } from "./Toast/Toast";

export function NewPassword({ code, close }) {
  const [message, setMessage] = useState("");
  const [verified, setVerified] = useState(null); // Set initial state to null
  const [formData, setFormData] = useState({
    password: "",
    passwordConfirm: "",
  });
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Fetch to verify code on component mount
    function checkCode() {
      fetch("https://inventy.redata.se/inventdb/api_recoverPassword.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ command: "checkCode", code }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.success) {
            setVerified(true); // Code is verified successfully
          } else {
            setVerified(false); // Invalid code
            setMessage("Felaktig länk");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setMessage("Ett fel inträffade när du försökte verifiera länken.");
          setVerified(false);
        });
    }

    checkCode(); // Run the function when component is mounted
  }, [code]); // Only run when `code` changes

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    // Add your password save logic here
    if (formData.password !== formData.passwordConfirm) {
      setMessage("Lösenorden matchar inte");
      return;
    }

    // Example of further password save logic
    fetch("https://inventy.redata.se/inventdb/api_recoverPassword.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        command: "resetPassword",
        password: formData.password,
        code,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          notify("success", "Lösenordet har sparats");
          setTimeout(() => {
            const queryParams = new URLSearchParams(window.location.search);
            queryParams.delete("code");
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}?${queryParams.toString()}`,
            );
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Ett fel inträffade när du försökte spara lösenordet.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setMessage("Ett fel inträffade när du försökte spara lösenordet.");
      });
  };

  if (verified === null) {
    // Still checking the code
    return <div>Kontrollerar länk...</div>;
  }

  return (
    <div className="login-container">
      <img src={FullLogo} alt="Inventory Manager" width="70%" />
      <h2 style={{ color: "var(--block)" }}>Skapa nytt lösenord</h2>
      {verified === false ? (
        <div className="message">Felaktig länk</div>
      ) : (
        <>
          <div className="input-field">
            <input
              type="password"
              placeholder="Lösenord"
              value={formData.password}
              onChange={handleChange}
              name="password"
            />
          </div>
          <div className="input-field">
            <input
              type="password"
              placeholder="Repetera lösenord"
              value={formData.passwordConfirm}
              onChange={handleChange}
              name="passwordConfirm"
            />
          </div>
          <button className="login-button" onClick={handleSubmit}>
            Spara
          </button>
          <div className="message">
            {message}
          </div>
        </>
      )}
    </div>
  );
}
